import React, { useRef, useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardActionArea,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import smallCar from "../Assets/small-car.png";
import mediumCar from "../Assets/medium-car.png";
import largeCar from "../Assets/large-car.png";
import cabriolet from "../Assets/cabriolet.png";
import suv from "../Assets/suv.png";
import minivan from "../Assets/minivan.png";
import premium from "../Assets/premium.png";

const categories = [
  { label: "Carro Pequeno", icon: smallCar },
  { label: "Carro Médio", icon: mediumCar },
  { label: "Carro Grande", icon: largeCar },
  { label: "Cabriolet", icon: cabriolet },
  { label: "Mini Van", icon: minivan },
  { label: "Premium", icon: premium },
  { label: "SUV", icon: suv },
];

const CarCategorySelector = ({ selected, onSelect }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm")); // Detect small screens (mobile)
  const scrollRef = useRef(null);

  // Smooth scrolling behavior for touch devices
  useEffect(() => {
    const container = scrollRef.current;
    if (container) {
      container.style.scrollBehavior = "smooth";
      container.style.webkitOverflowScrolling = "touch"; // Smooth touch scrolling for iOS
    }
  }, []);

  return (
    <Box
      sx={{
        position: "relative",
        width: "auto",
        overflowX: "auto",
        height: "150px",
      }}
    >
      <Grid
        container
        spacing={1}
        ref={scrollRef}
        sx={{
          flexWrap: "nowrap",
          overflowX: "auto",
          scrollbarWidth: "thin", // For Firefox
          "&::-webkit-scrollbar": {
            height: "6px", // Thinner scrollbar for Chrome/Safari
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "rgba(0,0,0,0.3)",
            borderRadius: "3px",
          },
        }}
      >
        {categories.map((category, index) => (
          <Grid
            item
            key={index}
            sx={{
              flex: "0 0 auto",
              width: "120px",
            }}
          >
            <Card
              variant="outlined"
              sx={{
                borderRadius: 3,
                backgroundColor: selected === index ? "#EE8013" : "white",
                textAlign: "center",
                height: "90px",
                width: "100%",
              }}
            >
              <CardActionArea onClick={() => onSelect(index)} sx={{ p: 1.5 }}>
                <Box display="flex" justifyContent="center">
                  <img
                    src={category.icon}
                    alt={category.label}
                    style={{ height: 30, width: "auto" }}
                  />
                </Box>
                <Typography mt={0.5} variant="body2">
                  {category.label}
                </Typography>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
      {/* Visual indicator for small screens */}
      {isSmallScreen && (
        <Typography
          variant="caption"
          color="textSecondary"
          sx={{
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            whiteSpace: "nowrap",
          }}
        >
          ← Swipe to see more →
        </Typography>
      )}
    </Box>
  );
};

export default CarCategorySelector;
